export enum MerchCapEnum {
  ConsentTerms = 'Akceptuję <a href="https://mubi.pl/dokumenty/regulamin-zakupu-produktow-tymka-upsell.pdf" target="_blank" rel="noopener noreferrer">Regulamin realizacji zamówienia</a> produktu oraz zapoznałem się z <a href="https://mubi.pl/dokumenty/klauzula-rodo-produkty-tymka-upsell.pdf" target="_blank" rel="noopener noreferrer">Klauzulą informacyjną RODO</a>.',
  ContactDataNote = 'Dane kontaktowe wyłącznie na potrzebę wysyłki czapki.',
  DeliveryHeading = 'Dane do dostawy czapki',
  DeliveryMethodInPost = 'Kurier InPost (19,90 zł)',
  Description1 = '100% zysku trafia na budżet wyścigowy Tymka. ',
  Description2 = 'Specjalna zniżka dla klientów Mubi.',
  LearnMore = 'Dowiedz się więcej',
  LimitedEdition = 'Edycja Limitowana',
  LowestPriceInfo = 'Najniższa cena z 30 dni przed obniżką: 129,00 zł',
  PurchaseInfoPrefix = 'Dodane do zakupu!',
  PurchaseInfoText = 'Oficjalna Czapka Tymka Kucharczyka z dostawą. Zamawiasz z obowiązkiem zapłaty.',
  SellerNote = 'Sprzedawcą i realizującym zamówienie czapki jest Digibits sp. z o.o.',
  SupportSlogan = '"Porównujesz ubezpieczenia, wspierasz polskie marzenia."',
  Title = 'Oficjalna czapka Tymka Kucharczyka',
}
